module.exports = __webpack_public_path__ + "img/active-18.0cba07da.svg";